/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={<>轨迹</>}
                description="实时精准记录您的移动轨迹，轻松回放路线，掌握每一次出行足迹。"
              />
              <RotatingCardBack
                image={bgBack}
                title="轨迹"
                description="实时精准记录您的移动轨迹，轻松回放路线，掌握每一次出行足迹。"
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="精准定位，全程追踪"
                  description="采用高精度GPS与多卫星系统协同定位，无论城市通勤还是户外徒步，都能稳定、准确地记录您的移动轨迹。"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="实时记录，随时掌控"
                  description="开启行程后自动开始记录，地图上实时显示当前位置与已行路径，支持途中暂停或继续，操作便捷，行程尽在掌握。"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="轨迹回放，重温旅程"
                  description="行程结束后可一键回放完整路线，结合时间、距离、速度等信息，生动还原每一段出行细节。"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="历史管理，清晰有序"
                  description="所有轨迹按时间智能归档，列表与地图双视图切换，快速定位目标行程，轻松重温每一次出行足迹。"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
